var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 35,
    viewBox: "0 0 177 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 6L44 5C43.0741 4.67442 42 4.54264 42 4C42 3.4031 43.3634 3 44 3C45.0995 3 45.3056 3.07752 46 4L49 3C48.1898 1.42636 46.4884 0 44 0C41.0487 0 39 1.55814 39 4C39 5.89922 39.6852 7.07752 42 8L44 9C44.9838 9.43411 45 9.34884 45 10C45 10.6512 44.9259 11 44 11C42.3797 11 41.7523 9.86822 41 9L38 11C39.0417 12.845 41.3959 14 44 14C46.9513 14 49 12.6589 49 10C49.0579 7.99225 47.3727 6.97674 45 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 5L72 0H68L73 9V14H77V9L82 0H78L75 5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91 8H95V5H91V3H97V0H87V14H97V11H91V8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 7L103 0H102V14H106V7L114 14H115V0H111V7Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134 0H130L126 6V0H122V14H126V7L131 14H135L130 7L134 0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145 0C140.858 0 138 3.03876 138 7C138 11.0155 140.858 14 145 14C149.142 14 153 10.9612 153 7C153 3.03876 149.198 0 145 0ZM146 11C143.761 11 142 9.33333 142 7C142 4.72093 143.761 3 146 3C148.183 3 149 4.72093 149 7C149 9.33333 148.127 11 146 11Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59 0L52 14H56L57 12H62L63 14H67L60 0H59ZM57 10L59 5H60L61 10H57Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21H47L43 27V21H39V34H43V28L48 34H52L47 27L51 21Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115 28H119V26H115V24H121V21H111V34H121V31H115V28Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136 28L128 21H127V35H131V28L139 35H140V21H136V28Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M158 21H154L150 27V21H146V34H150V28L155 34H159L154 27L158 21Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169 21C164.858 21 162 24.0388 162 28C162 32.0155 164.858 35 169 35C173.142 35 177 31.9612 177 28C177 24.0388 173.142 21 169 21ZM169 32C166.761 32 166 30.3333 166 28C166 25.7209 166.761 24 169 24C171.183 24 173 25.7209 173 28C173 30.3333 171.183 32 169 32Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26H61V21H57V34H61V29H66V34H70V21H66V26Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104 25C104 22.2329 101.932 21 99 21H93V34H97V30H98L101 34H105L102 29C103.303 28.3213 104 26.6707 104 25ZM99 27H97V24H99C99.9774 24 100 24.1124 100 25C100 25.9398 100.032 27 99 27Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21L74 35H78L79 33H84L85 35H89L82 21H81ZM79 31L81 26L83 31H79Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15L23 8C23.3962 9.04069 23 9.68545 23 11H25C25 10.507 25.0566 10.493 25 10C24.8302 8.68545 24.566 7.15023 24 6L27 3L24 0L22 3C19.9623 1.13772 16.6226 0 13 0C9.26415 0 6.15094 1.02817 4 3L1 0L0 2L3 5C1.64151 6.80751 1 8.53521 1 11H3C3 8.9734 3.03774 7.36933 4 6L21 24C20.3208 27.9437 18.2642 32 13 32C7.28302 32 4 27.82 4 23H0C0 30.2848 5.07547 35 13 35C21.3208 35 25 29.0657 25 22H22L16 15ZM13 2C15.8302 2 18.0755 2.24726 20 4L13 13L5 5C6.98113 3.19249 10.1132 2 13 2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.57f25a86f631dc8ef1a9ef37da3b297f.svg";
export { ForwardRef as ReactComponent };